import React, { useState, useEffect } from "react";
import { LayoutEdicion } from "..";
import { VideoPlayer } from "../../componentes";
import { useLocation } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

export default function PlayVideos() {
  const [jugada, setJugada] = useState([]);
  const [isRecord, setIsRecord] = useState(false);
  const location = useLocation();
  let slug =
    location.pathname.indexOf("playVideos") > -1
      ? location.pathname.replace("/app/playVideos/", "")
      : location.pathname.replace("/app/recordVideos/", "");
  slug.replace("/record", "");
  let playId = slug;
  let user = secureLocalStorage.getItem("userLocal");

  useEffect(() => {
    if (user !== null) setJugada(user.plays[playId]);
  }, [user]);
  useEffect(() => {
    /* iOS re-orientation fix */
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i)
    ) {
      /* iOS hides Safari address bar */
      window.addEventListener("load", function () {
        setTimeout(function () {
          window.scrollTo(0, 1);
        }, 1000);
      });
    }
    if (location.pathname.indexOf("recordVideos") > -1) setIsRecord(true);
  }, []);

  return (
    <LayoutEdicion id="video-player">
      <VideoPlayer jugada={jugada} isRecord={isRecord} />
    </LayoutEdicion>
  );
}
